<div class="layout-col p-lg">
  <h2>{{ 'Stückzahl zuweisen' | translate }}</h2>

  <form #frm="ngForm" class="flex layout-col">
    <mat-form-field>
      <mat-label>{{ 'context.quantity' | translate }}</mat-label>
      <elder-quantity-input
        name="quantity"
        placeholder="{{ 'context.quantity' | translate }}"
        required
        [min]="1"
        [max]="unPackagedPiecesCount"
        [(ngModel)]="quantity"
      >
      </elder-quantity-input>
      <mat-error elderValidationError></mat-error>
    </mat-form-field>
  </form>

  <div class="layout-row place-end-center gap-xl">
    <button mat-button mat-dialog-close>
      {{ 'actions.cancel' | translate }}
    </button>

    <button mat-button [mat-dialog-close]="quantity" [disabled]="!frm.form.valid">
      {{ 'actions.ok' | translate }}
    </button>
  </div>
</div>
